<template>
    <div class="content daily">
        <div class="content-wrap analysis" v-if="results.length">
            <Back url="/aola" text="首页"/>
            <div class="scroll-content middle analysis-content" ref="content">
                <QueItem
                    :question="results[index] ? results[index].quiz : {}"
                    :disabled="true"
                    :val="_results[index]">
                    <span slot="queIndex">
                        {{index + 1}}/{{results.length}}
                    </span>
                    <i slot="icon" slot-scope="{data}" v-if="data.checked " :class="data.checked && results[index].is_right ?'icon icon-tick' : 'icon icon-cross' "/>
                </QueItem>
                <p class="analysis-res">正确答案：{{['A', 'B', 'C', 'D'][results[index].quiz.right_seq_num - 1]}}</p>
                <p>解析: {{results[index].quiz.analysis}}</p>
            </div>
            <div class="bottom-wrap">
                <div class="custom-btn" :disabled="!index" @click="() => !index ? '' : index--">上一题</div>
                <div class="custom-btn" v-if="index < results.length - 1" @click="() => index++">下一题</div>
                <div class="custom-btn" v-if="index == results.length - 1" @click="$router.go(-1)">查看结果</div>
            </div>
            <img src="https://guokrapp-static.guokr.com/FuiV4SQGxoFcj1EkFiKX_1-A0sWr" alt="" class="p2">
        </div>
    </div>
</template>

<script>
import { arrRenameKey } from '@/utils/func';
import QueItem from '@/components/Question';
import { cacQuizResultResultIdGet } from '@/apis/cac'
import Back from '@/components/Back'

export default {
    name: 'ques',
    components: {
        QueItem,
        Back
    },
    watch: {
        index() {
            this.$refs.content.scrollTop = 0
        }
    },
    computed: {
        _results() {
            const [ ...res ] = this.results;
            return arrRenameKey(res, {answer_seq_num: 'seq_id'})
        }
    },
    data() {
        return {
            index: 0,
            results: []
        };
    },
    mounted() {
        this.getAnalysis()
    },
    methods: {
        async getAnalysis() {
            try {
                const {
                    body
                } = await cacQuizResultResultIdGet({
                    params: {
                        resultId: this.$route.params.result_id
                    }
                })

                this.results = body
            } catch (error) {
                this.$router.replace('/aola')
            }
        },
    }
};
</script>
<style lang="less" scoped>
.analysis {
    /deep/.back {
        top: auto;
        left: auto;
        bottom: 0;
        right: 1vw;
        font-size: 3vw;
        opacity: .7;
        z-index: 1;
        width: auto;
        height: 3vw;
        padding: 1vw;
        .icon {
            margin-right: 1vw;
            font-size: 2vw;
        }
    }
    /*控制整个滚动条*/
    ::-webkit-scrollbar {
        background-color: transparent;
    }

    /*滚动条两端方向按钮*/
    ::-webkit-scrollbar-button {
        background-color: transparent;
    }

    /*滚动条中间滑动部分*/
    ::-webkit-scrollbar-thumb {
        background-color: transparent;
    }

    /*滚动条右下角区域*/
    ::-webkit-scrollbar-corner {
        background-color: transparent;
    }
    &.content-wrap {
        background-image: url(https://guokrapp-static.guokr.com/FgMdZ1-r6YLThoYYCdtFfwxybB9V);
        background-position: bottom center;
    }
    
    .btn {
        margin-top: 6vh;
        &:first-child{
            margin-right: 14vw;
        }
    }
    p{
        margin: 0;
        font-size: 3.8vw;;
        // font-size: 14px;;
        margin-top: 2rem;
        color: #7d8187;
        line-height: 2;
    }
    .analysis-res {
        margin-top: 4rem;
    }
    .analysis-content {
        /deep/.icon {
            margin-top: .3rem;
            margin-right: 2vw;
            // font-size: 1.5rem;
            font-size: 3.2vw;
        }
    }
}
.daily{
    /deep/.van-loading {
        text-align: center;
    }
    .scroll-content{
        flex: 1;
        margin: 4.7rem auto 15px;
        background-image: url(https://guokrapp-static.guokr.com/FtksaXpeKqCmniF2AjvtRGRFbPw2);
        background-size: calc(100% + 20vw) calc(100% + 20vw);
        background-position: center;
        background-repeat: no-repeat;
        padding: 0;
        width: 90vw;
        border: 10vw solid transparent;
        box-sizing: border-box;
        .question-item {
            /deep/p, /deep/span {
                font-size: 4vw;
                color: #3F3F3F;
            }
            /deep/.radio-icon-round {
                margin-top: .6vw;
                width: 3.2vw;
                height: 3.2vw;
                margin-right: 2vw;
                border: 1px solid #3F3F3F;
                &.active::before {
                    width: 2vw;
                    height: 2vw;
                    color: #3D4FA5;
                }
            }
            /deep/.van-radio-group {
                .van-radio {
                    align-items: center;
                }
                .van-radio__label {
                    color: #3f3f3f;
                }
                .radio-icon-round {
                    margin-top: 0;
                }
                .icon-tick::before {
                    color: #40E54C;
                }
            }
        }
    }
    .bottom-wrap {
        display: flex;
        justify-content: center;
        margin-bottom: 60px;
        .custom-btn {
            width: 34vw;
            height: 15vw;
            background-image: url(http://guokrapp-static.guokr.com/FjekSFAdnlWpwhJFiR-uG5hO5EU-);
            background-size: 100% 100%;
            line-height: 15vw;
            text-align: center;
            color: #007342;
            // font-size: 20px;
            font-size: 5vw;
            position: relative;
            z-index: 100;
            font-weight: bolder;
            &[disabled] {
                background-image: url(http://guokrapp-static.guokr.com/FgsfzzQ2uABmkxbJerympCD_8Owg);
                color: #fff;
            }
            &:first-child{
                margin-right: 15px;
            }
        }
    }

    .p2 {
        position: absolute;
        bottom: 0;
        left: 4vw;
        width: 15vw;
    }
}
</style>
